export default "__VITE_ASSET__CjbnUBES__"